import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div data-testid="admin-auth-loading" className="flex min-h-screen items-center justify-center bg-[#FDFBF7] font-serif text-3xl text-[#1C1613]">Loading editorial access...</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
